<template>
  <section>
    <v-row :key="item.id" v-for="item in processes">
      <v-col sm="12" md="9">
        <v-card min-height="100%">
          <v-card-title>{{ item.workorder.name }} Instructions</v-card-title>
          <v-card-subtitle>{{ item.workorder.forgeID }}</v-card-subtitle>
          <v-card-text v-html="item.workorder.richtext" />
        </v-card>
      </v-col>
      <v-col sm="12" md="3">
        <WorkOrderParameters :workid="item.workorder.id" />
      </v-col>
      <v-col sm="12">
        <v-toolbar dense>
          <v-toolbar-title>
            <v-icon left>fas fa-cube</v-icon>
            Batches
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
        <template v-for="batch in item.workorder.children">
          <v-col sm="12" md="6" lg="4" :key="batch.id">
            <BatchNotesCard :batch="batch"  />
          </v-col>
        </template>
    </v-row>
  </section>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
import WorkOrderParameters from "../WorkOrders/WorkOrderParameters";
import BatchNotesCard from "../Batch/BatchNotesCard";
export default {
  name: "ToolProcessInstructions",
  components: {BatchNotesCard, WorkOrderParameters },
  props: {
    toolid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    processes() {
      return ToolProcess.query()
        .where("tool_id", parseInt(this.toolid))
        .where("in_process", true)
        .with("workorder.children")
        .get()
    }
  }
}
</script>
